/*eslint-disable*/ export const messages = JSON.parse("{\"radio-group.label.optional\":[\"Valinnainen\"],\"radio-group.validation.required\":[\"Valitse vaihtoehto.\"]}");
//# sourceMappingURL=messages.mjs.map